// extracted by mini-css-extract-plugin
export default {"toolTip":"toolTipCompoStyle_toolTip__bxvQC","toolTipText":"toolTipCompoStyle_toolTipText__ecfwH"};